
import React from 'react';
import { FileQuestion } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

interface EmptyStateProps {
  hasFilters?: boolean;
  category?: string;
  onResetFilters?: () => void;
}

const EmptyState = ({ 
  hasFilters = false,
  category = 'all',
  onResetFilters
}: EmptyStateProps) => {
  const getCategorySpecificMessage = () => {
    switch (category) {
      case 'trending':
        return "No profiles found. Try adding some filters or check back later when more designers join the platform.";
      default:
        return "No profiles found that match your criteria. Try adjusting your filters to see more results.";
    }
  };

  return (
    <div className="flex flex-col items-center justify-center text-center p-8 bg-muted/30 rounded-lg space-y-4">
      <FileQuestion className="h-12 w-12 text-muted-foreground" />
      
      <div className="space-y-2">
        <h3 className="text-lg font-medium">No Profiles Found</h3>
        
        <p className="text-muted-foreground max-w-md">
          {hasFilters 
            ? "No profiles match your current filter criteria."
            : getCategorySpecificMessage()
          }
        </p>
      </div>
      
      {hasFilters && onResetFilters && (
        <Button onClick={onResetFilters} variant="outline">
          Reset Filters
        </Button>
      )}
      
      {!hasFilters && (
        <div className="space-y-2">
          <p className="text-sm text-muted-foreground">
            Check back soon or browse other designers below.
          </p>
          <Link to="/dashboard/profile">
            <Button variant="outline" size="sm">
              Create Your Profile
            </Button>
          </Link>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
